import React from 'react';
import { useAuthContext } from '../contexts/AuthContext';

const PlaceholderDashboard: React.FC = () => {
    const { isSuperAdmin, isSalonStaff, isSalonOwner } = useAuthContext();
    let title = 'Dashboard';
    if (isSuperAdmin) title = 'Super Admin Dashboard (placeholder)';
    else if (isSalonStaff) title = 'Salon Staff Dashboard (placeholder)';
    else if (isSalonOwner) title = 'Salon Owner Dashboard (placeholder)';
    return (
        <div style={{ padding: 24 }}>
            <h1>{title}</h1>
            <p>Phase 1: Full dashboard will be migrated in later phases.</p>
        </div>
    );
};

export default PlaceholderDashboard;
